module.exports = __webpack_public_path__ + "static/media/Comp-1.900d3ee2.gif";